import { createContext } from "react";
const StaffContext = createContext();
export default StaffContext;

